import React from 'react';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/servicesStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { CaptionBold, HeadingS, HeadingSBold } from 'components/Typography/Typography';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useHistory } from 'react-router';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IAccordionContentProps {
	tiles: types.newServices.ISingleServiceTile[];
	selectedAccountId: string | null;
}

const AccordionContent = ({ tiles, selectedAccountId }: IAccordionContentProps) => {
	const classes = useStyles();
	const history = useHistory();

	const addNewService = (selectedType: types.newServices.serviceType) => {
		history.push(`/dashboard/services/add/${selectedAccountId}/${selectedType}`);
	};
	return (
		<GridContainer justify="flex-start" className={classes.accordionContentWrapper}>
			<>
				{tiles.map((tile, index) => {
					if (tile.hide) return null;
					return (
						<GridItem xs={12} sm={6} md={4} key={index} className={classes.accordionTileWrapper}>
							<div
								id={`${tile.path}-tile`}
								className={classNames(classes.accordionTile, {
									[classes.accordionTileDisabled]: !!tile.disabled,
								})}
								onClick={() => !tile.disabled && addNewService(tile.path)}
							>
								<div
									className={classNames(classes.iconWrapper, {
										[classes.iconDisabledWrapper]: !!tile.disabled,
									})}
								>
									{tile.icon}
								</div>
								<div
									className={classNames({
										[classes.tileNameDisabled]: !!tile.disabled,
									})}
								>
									<HeadingSBold color="primary-light" disableMargin>
										{tile.name}
									</HeadingSBold>
									{tile.helperText}
								</div>
								<ConditionalRender
									show={!!tile.disabled}
									onTrue={() => (
										<div className={classes.comingSoon}>
											<CaptionBold disableMargin>{translate('services.coming.soon')}</CaptionBold>
										</div>
									)}
								/>
							</div>
						</GridItem>
					);
				})}
			</>
			<ConditionalRender
				show={!tiles || tiles.length <= 0}
				onTrue={() => (
					<GridItem>
						<HeadingS color="disabled-light">
							{translate('numbers.services.no.services.available')}
						</HeadingS>
					</GridItem>
				)}
			/>
		</GridContainer>
	);
};

export default AccordionContent;
